<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="hasData()"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF ASSETS, LIABILITIES AND EXPENSES</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-4">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <ng-container *ngFor="let section of sections">
    <ng-container *ngIf="hasSectionData(section)">
      <div class="row mb-3">
        <div class="col-12 text-center assets-liabilities-section-title">
          {{ section }}
        </div>
      </div>

      <ng-container *ngFor="let table of getTablesForSection(section)">
        <div
          style="page-break-inside: avoid;"
          class="row mb-5"
          *ngIf="shouldRenderTable(table)"
        >
          <ng-container *ngIf="getRows(table) as rows">
            <div class="col-12 text-center font-weight-bold mb-3" *ngIf="!table.displayAsText">
              <span *ngIf="table.parent">{{ table.parent }} — </span>{{ table.title }}
            </div>

            <div class="col-12 mb-3" *ngIf="table.displayAsText">
              <div class="return-view-text-fields">
                <div class="return-view-text-field">
                  <span class="return-view-text-label">{{ table.title }}:</span>
                  <span class="return-view-text-value">{{ getTextFieldAmount(rows) | currencySeparatorBD }}</span>
                </div>
              </div>
            </div>

            <div class="col-12" *ngIf="!table.displayAsText">
              <table class="table table-bordered assets-liabilities-details-table">
                <thead>
                  <tr class="text-center">
                    <th></th>
                    <th *ngFor="let column of table.columns">{{ column.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of rows; let rowIndex = index">
                    <td class="text-center">{{ rowIndex + 1 }}</td>
                    <td
                      *ngFor="let column of table.columns"
                      [ngClass]="{ 'text-right pr-3': column.isAmount }"
                    >
                      <ng-container *ngIf="column.isAmount">
                        {{ getValue(row, column) | currencySeparatorBD }}
                      </ng-container>
                      <ng-container *ngIf="!column.isAmount">
                        {{ getValue(row, column) }}
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
                <tfoot *ngIf="table.showSubTotal">
                  <tr class="font-weight-bold">
                    <td></td>
                    <td
                      *ngFor="let column of table.columns; let columnIndex = index"
                      [ngClass]="{ 'text-right pr-3': column.isAmount }"
                    >
                      <span *ngIf="columnIndex === 0 && !shouldShowSubtotalAmount(table, column)">
                        Sub Total
                      </span>
                      <span *ngIf="shouldShowSubtotalAmount(table, column)">
                        {{ getAmountColumnTotal(table, rows, column) | currencySeparatorBD }}
                      </span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="hasSourceFundData">
    <div class="row mb-3">
      <div class="col-12 text-center assets-liabilities-section-title">
        Sources of Fund
      </div>
    </div>

    <div style="page-break-inside: avoid;" class="row mb-5">
      <!-- <div class="col-12 text-center mb-3 font-weight-bold">
        Sources of Fund
      </div> -->
      <div class="col-12">
        <table class="table table-bordered assets-liabilities-source-fund-table">
          <tbody>
            <tr>
              <td class="text-center">Sources</td>
              <td class="text-center">Particulars</td>
              <td class="text-center">Amount</td>
            </tr>
            <tr>
              <td class="text-start">Taxable Income (excluding non-cash benefits)</td>
              <td class="text-center"><b>-</b></td>
              <td class="text-right">{{ taxableIncome | currencySeparatorBD }}</td>
            </tr>
            <tr>
              <td class="text-start">Tax Exempted Income</td>
              <td class="text-center"><b>-</b></td>
              <td class="text-right">{{ taxExemptedIncome | currencySeparatorBD }}</td>
            </tr>
            <tr *ngFor="let item of otherReceipt; let i = index">
              <td *ngIf="i === 0" class="text-start" [attr.rowspan]="otherReceipt.length">
                Receipt of Gift and Others
              </td>
              <td [class]="item?.description == '-' ? 'text-center font-bold' : 'text-start'">
                {{ item?.description }}<ng-container *ngIf="item?.relatedIN"> - {{ item?.relatedIN }}</ng-container>
              </td>
              <td class="text-right">{{ item?.value | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <div style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12">
      <div class="text-center font-weight-bold mb-2">Summary</div>
      <table class="table table-bordered assets-liabilities-summary-table">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let summaryItem of summaryItems">
            <td>{{ summaryItem.title }}</td>
            <td class="text-right pr-3">
              {{ getSummaryValue(summaryItem.key) | currencySeparatorBD }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
